import { render, staticRenderFns } from "./TicketResuelto.vue?vue&type=template&id=bb11cd44"
import script from "./TicketResuelto.vue?vue&type=script&lang=js"
export * from "./TicketResuelto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports